export type Palette = {
  id: string
  name: string
  /** AI Engineering / main accent */
  primary: string
  /** secondary accent (routes, gradients) */
  accent: string
  /** AI Security */
  security: string
  /** AI Infrastructure */
  infra: string
  /** page background */
  bg: string
  /** soft nebula tints used by the background scene */
  nebula: [string, string, string]
}

/** Approved palette: «Глубокий космос» (2026-09-24). */
export const palettes: Palette[] = [
  {
    id: 'deep-space',
    name: 'Глубокий космос',
    primary: '#7cc8ff',
    accent: '#a99bff',
    security: '#ff8fb3',
    infra: '#ffd28a',
    bg: '#050816',
    nebula: ['#1d3470', '#43306f', '#153a5c'],
  },
]

export const defaultPaletteId = 'deep-space'

export function getPalette(id: string | null | undefined) {
  return palettes.find((palette) => palette.id === id) || palettes.find((palette) => palette.id === defaultPaletteId)!
}

function hexToRgb(hex: string) {
  const value = Number.parseInt(hex.slice(1), 16)
  return `${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}`
}

export function applyPalette(palette: Palette) {
  const style = document.documentElement.style
  style.setProperty('--cyan', palette.primary)
  style.setProperty('--cyan-rgb', hexToRgb(palette.primary))
  style.setProperty('--violet', palette.accent)
  style.setProperty('--violet-rgb', hexToRgb(palette.accent))
  style.setProperty('--amber', palette.infra)
  style.setProperty('--security', palette.security)
  style.setProperty('--security-rgb', hexToRgb(palette.security))
  style.setProperty('--infra-rgb', hexToRgb(palette.infra))
  style.setProperty('--bg', palette.bg)
  style.setProperty('--bg-rgb', hexToRgb(palette.bg))
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', palette.bg)
}
